(() => {
  const html = document.documentElement;
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const drawer = qs('[data-cart-drawer]');
  const overlay = qs('[data-cart-overlay]');
  const body = qs('[data-cart-body]');
  const subtotalEl = qs('[data-cart-subtotal]');
  if (!drawer || !overlay || !body || !subtotalEl) return;

  let lastFocus = null;

  const fmt = (cents) => {
    const amount = Math.round((Number(cents) || 0) / 100);
    return `USD $${amount}`;
  };
  const esc = (str) => String(str || '')
    .replaceAll('&','&amp;').replaceAll('<','&lt;').replaceAll('>','&gt;')
    .replaceAll('"','&quot;').replaceAll("'","&#039;");

  async function fetchCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('cart.js failed');
    return res.json();
  }

  async function changeLine(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity })
    });
    if (!res.ok) throw new Error('change.js failed');
    return res.json();
  }

  function updateCount(count) {
    qsa('[data-cart-count]').forEach((el) => (el.textContent = String(count || 0)));
  }

  function renderCart(cart) {
    updateCount(cart.item_count);
    subtotalEl.textContent = fmt(cart.total_price);

    if (!cart.items || cart.items.length === 0) {
      body.innerHTML = `<div class="cart-drawer__empty">Your cart is empty.</div>`;
      return;
    }

    body.innerHTML = cart.items.map((item) => {
      const variant = item.variant_title && item.variant_title !== 'Default Title'
        ? `<div class="cart-drawer__variant">${esc(item.variant_title)}</div>`
        : '';

      const img = item.image
        ? `<img class="cart-drawer__img" src="${item.image}" alt="${esc(item.product_title)}">`
        : '';

      return `
        <div class="cart-drawer__item" data-key="${item.key}">
          <a class="cart-drawer__media" href="${item.url}">${img}</a>
          <div class="cart-drawer__info">
            <a class="cart-drawer__name" href="${item.url}">${esc(item.product_title)}</a>
            ${variant}
            <div class="cart-drawer__price">${fmt(item.final_line_price)}</div>

            <div class="cart-drawer__actions">
              <div class="cart-drawer__qty">
                <button type="button" class="cart-drawer__qtyBtn" data-qty-minus ${item.quantity <= 1 ? 'disabled' : ''}>−</button>
                <input class="cart-drawer__qtyInput" type="number" min="1" value="${item.quantity}" inputmode="numeric">
                <button type="button" class="cart-drawer__qtyBtn" data-qty-plus>+</button>
              </div>
              <button type="button" class="cart-drawer__remove" data-remove>Remove</button>
            </div>
          </div>
        </div>
      `;
    }).join('');
  }

  async function refresh() {
    const cart = await fetchCart();
    renderCart(cart);
  }

  function openDrawer() {
    lastFocus = document.activeElement;
    html.classList.add('is-cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    refresh().catch(() => {});
    qs('[data-cart-close]')?.focus();
  }

  function closeDrawer() {
    html.classList.remove('is-cart-drawer-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    lastFocus?.focus?.();
  }

  document.addEventListener('click', (e) => {
    const openBtn = e.target.closest('.js-cart-drawer-open');
    if (openBtn) {
      e.preventDefault();
      openDrawer();
      return;
    }

    if (e.target.matches('[data-cart-overlay]') || e.target.closest('[data-cart-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }

    const itemEl = e.target.closest('.cart-drawer__item');
    if (!itemEl) return;
    const key = itemEl.getAttribute('data-key');
    const input = qs('.cart-drawer__qtyInput', itemEl);

    if (e.target.closest('[data-remove]')) {
      changeLine(key, 0).then(renderCart).catch(() => {});
      return;
    }
    if (e.target.closest('[data-qty-minus]') && input) {
      const q = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      changeLine(key, q).then(renderCart).catch(() => {});
      return;
    }
    if (e.target.closest('[data-qty-plus]') && input) {
      const q = (parseInt(input.value, 10) || 1) + 1;
      changeLine(key, q).then(renderCart).catch(() => {});
      return;
    }
  });

  document.addEventListener('change', (e) => {
    const input = e.target.closest('.cart-drawer__qtyInput');
    if (!input) return;

    const itemEl = e.target.closest('.cart-drawer__item');
    if (!itemEl) return;

    const key = itemEl.getAttribute('data-key');
    const q = Math.max(1, parseInt(input.value, 10) || 1);
    changeLine(key, q).then(renderCart).catch(() => {});
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && html.classList.contains('is-cart-drawer-open')) closeDrawer();
  });

  window.CartDrawer = { open: openDrawer, close: closeDrawer, refresh };
})();